import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import clone from 'clone'
import { storePref, checkPref } from "helpers/pref"
import numeral from 'numeral'
import FullTable from "components/FullTable"
import ImageExport from "components/ImageExport"
import TaxValuesByLotType from "widgets/TaxValuesByLotType"
import colorArray from "helpers/colorArray"
import { Pie } from "react-chartjs-2"
import helpers from "helpers/helpers"
import { updateDates, getPayload } from "actions"


class DeveloperLotInventory extends Component {
	constructor(props) {
		super(props)

		this.state = {
			columns: [
				{
					Header: "Community",
					accessor: "property",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Subdivision",
					accessor: "subdivision",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Neighborhood",
					accessor: "neighborhood",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					display: true,
					name: "Lot Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					display: true,
					name: "Builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					accessor: "lot",
					display: true,
					className: "center",
					name: "Lot",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot"),
					Header: () => (
						<div
							style={{
								textAlign: "center",
							}}>
							Lot
						</div>
					),
				},
				{
					accessor: "block",
					display: true,
					className: "center",
					name: "Block",
					filterMethod: (f, r) => helpers.tableText(f, r, "block"),
					Header: () => (
						<div
							style={{
								textAlign: "center",
							}}>
							Block
						</div>
					),
				},
				{
					accessor: "section",
					display: true,
					className: "center",
					name: "Section",
					Header: () => (
						<div
							style={{
								textAlign: "center",
							}}>
							Section
						</div>
					),
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: () => (
						<div
							style={{
								textAlign: "right",
							}}>
							Base Lot Price
						</div>
					),
					accessor: "base_price",
					display: true,
					className: "right",
					name: "Base Price",
					filterMethod: (f, r) => helpers.tableText(f, r, "base_price"),
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("$0,0.00")
						}
						return "$0.00"
					},
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							if (v["base_price"]) {
								total += parseFloat(v["base_price"])
							}
						})
						if (typeof total == "number") {
							return numeral(total).format("$0,0.00")
						}
						return total
					},
				},
				{
					Header: () => (
						<div
							style={{
								textAlign: "right",
							}}>
							Premium
						</div>
					),
					accessor: "premium",
					display: true,
					className: "right",
					name: "Premium",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("$0,0.00")
						}
						return "$0.00"
					},
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							if (v["premium"]) {
								total += parseFloat(v["premium"])
							}
						})
						if (typeof total == "number") {
							return numeral(total).format("$0,0.00")
						}
						return total
					},
				},
				{
					Header: "Substantially Complete",
					accessor: "completed",
					name: "Substantially Complete",
					display: true,
				},
				{
					Header: "Substantial Complete Date",
					accessor: "completion",
					name: "Substantial Complete Date",
					display: true,
					Cell: (v) => {
						if (v.value) return moment.unix(v.value).format("M/DD/YY")
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Address",
					accessor: "address",
					name: "Address",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
			],
			finishedColumns: [
				{
					accessor: "section",
					display: true,
					Header: "Section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Subdivision",
					accessor: "subdivision",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Neighborhood",
					accessor: "neighborhood",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					accessor: "lot_type",
					display: true,
					Header: "Lot Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					accessor: "substantially_complete",
					display: true,
					Header: "Substantially Complete",
					filterMethod: (f, r) => helpers.tableText(f, r, "substantially_complete"),
				},
				/* {
					accessor: "acreage",
					display: true,
					Header: "Acreage",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							if (v["acreage"]) {
								total += parseFloat(v["acreage"])
							}
						})
						if (typeof total == "number") {
							return numeral(total).format("0,0.0000")
						}
						return total
					},
				}, */
				{
					accessor: "lots_remaining",
					display: true,
					Header: "Lots Remaining",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							if (v["lots_remaining"]) {
								total += parseInt(v["lots_remaining"])
							}
						})
						if (typeof total == "number") {
							return numeral(total).format("0,0")
						}
						return total
					},
				},
			],
			expectedDelivery: [
				{
					accessor: "section",
					display: true,
					Header: "Section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				/* {
					accessor: "acreage",
					display: true,
					Header: "Total Section Acreage",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							if (v["acreage"]) {
								total += parseFloat(v["acreage"])
							}
						})
						if (typeof total == "number") {
							return numeral(total).format("0,0.0000")
						}
						return total
					},
				}, */
			],
			sorted: [],
			filtered: [],
			showFilters: false,
			quarters: [],
		}

		for (let i = 0; i < 7; i++) {
			let q = moment().add(i, "quarter")
			let header = q.format("[Q]Q Y")
			let access = q.format("[Q]Q-Y")
			this.state.quarters.push(header)
			this.state.expectedDelivery.push({
				accessor: access,
				display: true,
				Header: header,
				Footer: (props) => {
					let total = 0
					_.forEach(props.data, (v) => {
						if (v[access]) {
							total += parseFloat(v[access])
						}
					})
					return total
				},
			})
		}
	}

	componentDidMount() {
		let f = {
			startDate: moment().startOf("day"),
			endDate: moment().endOf('day'),
		}
		this.props.updateDates(f)
	}

	developerInventory = () => {
		let ret = []
		_.forEach(this.props.payload.exec.lots, (r) => {
			if (!r.takedown_date && r.substantially_complete) {
			} else if (!r.substantially_complete) {
				return
			} else if (r.takedown_date && r.takedown_date < this.props.currentDates.startStamp) {
				return
			}
			let section = _.find(this.props.payload.public.sections, { id: r.section_id })
			if (!section) {
				console.log("no section")
				return
			}
			let builder = _.find(this.props.payload.public.builders, { id: r.builder })
			let neigh = _.find(this.props.payload.public.neighborhoods, { id: r.neighborhood })
			let sub = _.find(this.props.payload.public.subdivisions, { id: r.subdivision })
			let property = _.find(this.props.payload.public.properties, { id: r.property })
			if (!r.takedown_price) {
				r.takedown_price = 0
			}
			if (!r.base_price) {
				r.base_price = 0
			}
			if (!r.premium) {
				r.premium = 0
			}
			let type = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
			let takedown_price = r.takedown_price
			if(takedown_price) {
				takedown_price = parseFloat(takedown_price).toFixed(2)
			}
			ret.push({
				property: property ? property.name : "",
				builder: builder ? builder.name : "",
				section: r.section_name,
				block: r.block,
				lot: r.lot,
				completion: r.completion,
				lot_type: type ? type.name : "",
				takedown_date: r.takedown_date,
				takedown_price,
				base_price: r.base_price ? r.base_price.toFixed(2) : 0,
				premium: r.premium ? parseFloat(r.premium) : "0.00",
				completed: r.substantially_complete ? "Yes" : "No",
				address: r.address,
				neighborhood: neigh ? neigh.name : "",
				subdivision: sub ? sub.name : "",
			})
		})

		return ret
	}

	finishedInventory = () => {
		let ret = []
		let store = {}
		let model = {
			section_name: "",
			acreage: 0,
			lots_remaining: 0,
			lot_type: "",
		}
		_.forEach(this.props.payload.exec.lots, (r) => {
			if (!r.takedown_date || r.takedown_date > this.props.currentDates.startStamp) {
				let section = _.find(this.props.payload.public.sections, { id: r.section_id })
				let neigh = _.find(this.props.payload.public.neighborhoods, { id: r.neighborhood })
				let sub = _.find(this.props.payload.public.subdivisions, { id: r.subdivision })
				if (!section) {
					return
				}
				let type = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
				if (!type || !section) {
					console.error(`Cannot find type of section. Lot: ${r.id}`)
				}
				let path = `${section.name}`
				if (!_.has(store, path)) {
					_.set(store, path, _.clone(model), Object)
				}
				store[path].section = section.name
				store[path].acreage = section.acreage
				store[path].lots_remaining++
				store[path].lot_type = (type && type.name) || ""
				store[path].subdivision = sub ? sub.name : ""
				store[path].neighborhood = neigh ? neigh.name : ""
				store[path].substantially_complete = section.substantially_complete ? 'Yes' : 'No'
			}
		})

		_.forEach(store, (v, k) => {
			ret.push(v)
		})
		return ret
	}

	expectedDelivery = () => {
		let ret = []
		_.forEach(this.props.payload.public.sections, (r) => {
			if (!this.props.activeProperties.includes(r.property)) return
			if (r.completion) {
				let completion = moment.unix(r.completion).format("[Q]Q Y")
				let access = moment.unix(r.completion).format("[Q]Q-Y")
				if (this.state.quarters.includes(completion)) {
					// Go through lot types in this section
					_.forEach(r.lot_types, (v, k) => {
						let type = _.find(this.props.payload.public.lot_types, { id: parseInt(k) })
						if (!type) {
							console.log("no type")
							return
						}
						ret.push({
							section: r.name,
							acreage: r.acreage,
							[access]: v.total_lots,
						})
					})
				}
			}
		})
		return ret
	}

	storePref = (state) => {
		let storage = {}
		for (let v of state.columns) {
			storage[v.accessor] = v.display
		}
		storePref("takedown", storage)
	}

	filterChange = (e) => {
		if (!e.target.dataset.value) {
			return
		}
		let state = clone(this.state)
		let index = _.findIndex(state.columns, { name: e.target.dataset.value })
		state.columns[index].display = !state.columns[index].display
		this.storePref(state)
		this.setState(state)
	}

	checkboxChange = (e) => {
		let state = clone(this.state)
		let index = _.findIndex(state.columns, { name: e.target.name })
		state.columns[index].display = !state.columns[index].display
		this.setState(state)
	}

	renderFilters = () => {
		let checkboxes = []
		_.forEach(this.state.columns, (v) => {
			let index = _.findIndex(this.state.columns, { name: v.name })
			checkboxes.push(
				<li className="filterCheckboxes__item" key={v.name} data-value={v.name} onClick={this.filterChange}>
					<input
						type="checkbox"
						name={v.name}
						value={v.name}
						checked={this.state.columns[index].display}
						onChange={this.checkboxChange}
					/>
					{v.name}
				</li>
			)
		})

		return checkboxes
	}

	activeColumns = () => {
		let ret = _.filter(this.state.columns, { display: true })
		//console.log(ret)
		return ret
	}

	checkAll = (value) => {
		let state = clone(this.state)
		_.forEach(state.columns, (v, k) => {
			state.columns[k].display = value
		})
		this.storePref(state)
		this.setState(state)
	}

	toggle = () => {
		this.setState({ showFilters: !this.state.showFilters })
	}

	acreage = () => {
		let types = {
			"Substantially Complete": 0,
			"Pending Completion": 0,
		}
		let sections = _.filter(this.props.payload.public.sections, { property: this.props.activeProperties[0] })
		_.forEach(sections, (v) => {
			if (v.completion > this.props.currentDates.startStamp && v.acreage) {
				types["Pending Completion"] += v.acreage
			} else if (v.acreage) {
				types["Substantially Complete"] += v.acreage
			}
		})

		_.forEach(types, (v, k) => [(types[k] = numeral(v).format("00.000"))])

		const data = {
			labels: _.keys(types),
			datasets: [
				{
					data: _.values(types),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return <Pie data={data} options={opts} />
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="inventory">
					<div className="imageGroup">
						<Title title="Financial" custom={true} />
						<div className="content">
							<div className="statBox__row statBox__row--triple">
								<div className="statBox__box">
									<ImageExport name="SalesByLotType" />
									<h3 className="statBox__title">Total Acreage</h3>
									{this.acreage()}
								</div>
							</div>
							<h3 className="statBox__title">Developer-Owned Lot Inventory</h3>
							<FullTable
								data={this.finishedInventory()}
								columns={this.state.finishedColumns}
								name="finished"
								title="Finished Lot Inventory"
								classNames="small"
								pageSize={10}
							/>
							<h3 className="statBox__title">Developer Lot Inventory</h3>
							<FullTable
								data={this.developerInventory()}
								columns={this.activeColumns()}
								name="developer"
								title="Developer Lot Inventory"
								classNames="small"
								pageSize={40}
							/>
							<h3 className="statBox__title">Projected Lot Inventory</h3>
							<FullTable
								data={this.expectedDelivery()}
								columns={this.state.expectedDelivery}
								name="expected"
								title="Expected Lot Inventory"
								classNames="small"
								pageSize={10}
							/>
							<TaxValuesByLotType />
						</div>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
    return {
        currentDates: state.currentDates,
        compareDates: state.compareDates,
        payload: state.payload,
        payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({ updateDates, getPayload }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(DeveloperLotInventory)
